import React from "react";
import MenuSection from "../../components/Menu/MenuSection";
import { SurveyMenuItem } from "./SurveyMenuItem";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { BrandUtils } from "../../utils/brandUtils";
import { loadHomeSection } from "./loader";
import {
  CasinoDailyWishChunk,
  useIsCasinoDailyWishAvailable
} from "./CasinoDailyWish";
import { PageContextUtils } from "../../utils";

const Home = () => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const isCasinoDailyWishAvailable = useIsCasinoDailyWishAvailable();

  const getHomeSection = brandId => {
    if (Number.isNaN(Number(brandId))) return null;
    const { name } = PageContextUtils.getClientProviderData();
    const BrandHomeSection = loadHomeSection(brandId, name);
    return <BrandHomeSection />;
  };

  return (
    <MenuSection className="homeSection">
      {getHomeSection(brandId)}
      {BrandUtils.isPokerClient() !== true && <SurveyMenuItem />}
      {isCasinoDailyWishAvailable && <CasinoDailyWishChunk />}
    </MenuSection>
  );
};

export default React.memo(Home);

export * from "./SurveyMenuItem";
